module.exports = {
    close: {
        'zh-CN': '关闭',
		'zh-TW': '關閉',
        'en-US': 'close',
        'th-TH': 'close'
    },
    prevPage: {
        'zh-CN': '上一页',
		'zh-TW': '上一頁',
        'en-US': 'Preview',
        'th-TH': 'Preview'
    },
    nextPage: {
        'zh-CN': '下一页',
		'zh-TW': '下一頁',
        'en-US': 'Next',
        'th-TH': 'Next'
    }
};



// WEBPACK FOOTER //
// ./src/lang/news.js